import { useEffect, useRef } from "react";
import { env } from "./env";
import { useToast } from "./toast";

type NtfyMessage = {
  event: string;
  title?: string;
  message?: string;
};

const RECONNECT_DELAY = 3000;

export function useNtfy(topic: string | null) {
  const addToast = useToast();
  const wsRef = useRef<WebSocket | null>(null);
  const stopRef = useRef(false);

  useEffect(() => {
    if (!topic) return;

    stopRef.current = false;

    function connect() {
      if (stopRef.current) return;

      const wsUrl = env.VITE_NTFY_URL.replace(/^http/, "ws") + `/${topic}/ws`;
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;

      ws.onmessage = (e) => {
        try {
          const data: NtfyMessage = JSON.parse(e.data);
          if (data.event !== "message") return;
          addToast({ title: data.title, message: data.message ?? "" });
        } catch {
          // ignore malformed frames
        }
      };

      ws.onclose = () => {
        if (!stopRef.current) {
          setTimeout(connect, RECONNECT_DELAY);
        }
      };
    }

    connect();

    return () => {
      stopRef.current = true;
      wsRef.current?.close();
    };
  }, [topic, addToast]);
}
